import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getWfaSessions } from 'src/apps/wfa/services/WfaDashboardService';
import { TWfaSessionsResult } from 'src/apps/wfa/services/WfaDashboardServiceTypes';
import { WFA_SESSIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { ITableQueryParams } from 'src/common/types/TableQueryTypes';
import { IUseTableQueryParams } from 'src/common/types/UseTableQueryParamsType';

export const useWfaSessionsQuery = ({
	filters,
	sort,
	page,
	pageSize
}: IUseTableQueryParams): UseQueryResult<TWfaSessionsResult> => {
	const sessionsQuery = useQuery(
		[WFA_SESSIONS, filters, sort, page, pageSize],
		async (): Promise<TWfaSessionsResult> =>
			getWfaSessions({
				filterOptions: filters as ITableQueryParams['filterOptions'],
				sort,
				page,
				pageSize
			}),
		{
			keepPreviousData: true
		}
	);

	return sessionsQuery;
};
